import { render, staticRenderFns } from "./ResignedEmployeeList.vue?vue&type=template&id=24af47e4&scoped=true"
import script from "./ResignedEmployeeList.vue?vue&type=script&lang=js"
export * from "./ResignedEmployeeList.vue?vue&type=script&lang=js"
import style0 from "./ResignedEmployeeList.vue?vue&type=style&index=0&id=24af47e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24af47e4",
  null
  
)

export default component.exports